import { applyAuth0Theme } from "@/utils/theme";

import ResetPasswordForm from "./components/ResetPasswordForm";
import { useResetPasswordManager } from "./hooks/useResetPasswordManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function ResetPasswordScreen() {
    // Extracting attributes from hook made out of ResetPasswordInstance class of Auth0 React SDK
    const { resetPassword, texts, locales } = useResetPasswordManager();

    // Apply theme from SDK instance when screen loads
    applyAuth0Theme(resetPassword);
    return (
        // Applying UDS theme overrides using the "theme-universal" class
        <AuthLayout title={texts?.pageTitle || locales.pageTitle}>

            <ResetPasswordForm />

        </AuthLayout>
    );
}

export default ResetPasswordScreen;
